import request from '@/utils/request';


let server = {
	signUp: '/users', // 注册
  verifyMessage: '/verification_codes', // 短信验证
  captcha: '/captcha', // 图形验证
};


//  用户验证
export function signUp(params) {
	return request({
    	url: server.signUp,
	    method: 'post',
	    data:params
  	})

}
//  短信验证
export function verifyMessage(params) {
	return request({
    	url: server.verifyMessage,
	    method: 'post',
	    data:params
  	})
}

//  图形验证
export function getCaptcha(params) {
	return request({
    	url: server.captcha,
	    method: 'post',
	    data:params
  	})
}








// WEBPACK FOOTER //
// ./src/api/signUp.js